import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { IoCloseOutline } from "react-icons/io5";

function formatDateTime(dateStr, timeStr) {
  const dateTime = new Date(`${dateStr}T${timeStr}`);

  const weekday = dateTime.toLocaleString("en-US", { weekday: "short" });
  const month = dateTime.toLocaleString("en-US", { month: "short" });
  const day = dateTime.getDate();
  const year = dateTime.getFullYear();
  let time = dateTime.toLocaleString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  return `${weekday}, ${month} ${day}, ${year}, ${time}`;
}

export default function Barcode({ OnClose, seatNumber }) {
  const { user, chatData } = useAuth();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 10);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(OnClose, 300);
  };

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 bg-white shadow-xl transform transition-transform duration-300 ease-in-out ${
        isVisible ? "translate-y-0" : "translate-y-full"
      }`}
      style={{ height: "100%" }}
    >
      <div className="h-full w-screen">
        {/* HEADER & TABS */}
        <div style={{ backgroundColor: "rgb(22, 19, 22)" }}>
          <div className="flex items-center justify-between gap-4 pt-3 pb-3 pl-3 pr-3">
            <div className="flex gap-2 items-center overflow-hidden flex-1">
              <div className="flex justify-start">
                <button className="text-gray-200" onClick={handleClose}>
                  <IoCloseOutline size={33} />
                </button>
              </div>
              <div className="truncate flex-1 min-w-0">
                <p className="text-lg font-bold text-gray-200">
                  {chatData?.event_name}
                </p>
                <p className="text-gray-300 text-sm -mt-1 truncate">
                  {formatDateTime(chatData?.event_date, chatData?.event_time)} -{" "}
                  {chatData?.event_venue}
                </p>
              </div>
            </div>

            <div className="flex-shrink-0">
              <p className="text-gray-200">Help</p>
            </div>
          </div>
        </div>

        <div
          className="relative"
          style={{
            height: "100%",
            backgroundImage: `url(${chatData?.image_url})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            width: "100%",
          }}
        >
          <div className="absolute inset-0 bg-black opacity-50 z-10"> </div>

          <div className="absolute inset-0 z-20 flex flex-col px-8 pb-2 ">
            <div className="text-white  mt-16">
              <p className="text-xl font-bold text-center">
                {chatData?.ticket_type}
              </p>

              {chatData?.seat_no === "0" && user?.ga_design === "D2" ? (
                <div>
                  <div className="text-center text-md font-medium mt-1 text-gray-200">
                    General Admission
                  </div>
                  <div className="flex justify-around mt-3">
                    <div className="flex flex-col align-center text-center flex-1">
                      <p className="text-2xl text-gray-100 font-semibold">
                        {chatData?.section}
                      </p>
                    </div>

                    <div className="flex flex-col align-center text-center flex-1">
                      <p className="text-2xl text-gray-100 font-semibold">
                        {chatData?.row}
                      </p>
                    </div>

                    <div className="flex flex-col align-center text-center flex-1">
                      <p className="text-2xl text-gray-100 font-semibold">-</p>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="flex justify-around mt-8">
                  {/* <div className="flex flex-col align-center text-center ${user?.ga_design === 'D1'} ? '' : 'flex-1'"> */}
                  <div
                    className={`flex flex-col align-center text-center ${
                      chatData?.seat_no === "0" && user?.ga_design === "D1"
                        ? ""
                        : "flex-1"
                    }`}
                  >
                    <p className="text-md text-gray-100 font-thin">SEC</p>
                    <p className="text-xl text-gray-100 font-semibold">
                      {chatData?.section}
                    </p>
                  </div>

                  {chatData?.seat_no === "0" && user?.ga_design !== "D2" ? (
                    ""
                  ) : (
                    <div className="flex flex-col align-center text-center flex-1">
                      <p className="text-md text-gray-100 font-thin">ROW</p>
                      <p className="text-xl text-gray-100 font-semibold">
                        {chatData?.row}
                      </p>
                    </div>
                  )}

                  {chatData?.seat_no === "0" && user?.ga_design !== "D2" ? (
                    <div>
                      <p className="text-gray-100 text-xl font-semibold mt-1">
                        General Admission
                      </p>
                    </div>
                  ) : (
                    <div className="flex flex-col align-center text-center flex-1">
                      <p className="text-md text-gray-100 font-thin">SEAT</p>
                      <p className="text-xl text-gray-100 font-semibold">
                        {seatNumber}
                      </p>
                    </div>
                  )}
                </div>
              )}
            </div>

            {user?.barcode === "yes" ? (
              <div className="mt-14 mb-2 bg-white p-1 rounded-lg">
                {/* <img
                  src="../images/barr.gif"
                  alt=""
                  className="w-full object-cover"
                /> */}
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="w-full object-cover rounded-lg"
                >
                  <source src="/videos/bargif.mp4" type="video/mp4" />
                </video>

                <p className="font-bold mb-3 text-center text-gray-900">
                  Screenshots won't get you in
                </p>
              </div>
            ) : (
              <p className="text-white text-xl font-medium text-center mt-28 mb-16">
                Add to Wallet to enter the event.
              </p>
            )}

            <div className="flex justify-center mt-14">
              <div className="flex min-w-2/3 text-white gap-2 justify-center items-center p-4 bg-zinc-900 rounded-md">
                <img src="../images/applewallet.png" alt="" className="w-6" />
                <p className="text-md font-semibold">Add to Apple Wallet</p>
              </div>
            </div>
            <p className="text-gray-300 text-lg font-medium text-center mt-6">
              {chatData?.entry_info}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
